import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import "./search.less";
import {
  InputAdornment,
  TextField,
  Tooltip,
} from "@material-ui/core";
import FilterImage from "../../../public/img/common/Vector.svg";

const useStyles = makeStyles((theme) => ({
  search: {
    position: "relative",
    borderRadius: "2px",
    border: "1px solid lightgray",
    "&:hover": {
      backgroundColor: "white",
    },
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      //marginLeft: theme.spacing(1),
    },
  },
  searchIcon: {
    height: "100%",
    pointerEvents: "none",
    display: "flex",
    float: "left",
    // paddingTop: "8px",
    flexDirection: "row",
    alignItems: "center",
    padding: "8px 12px",
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "40ch",
      "&:focus": {
        width: "40ch",
      },
    },
  },
}));

/** set values */
SearchBar.propTypes = {
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
};

/** Search bar main function */
export default function SearchBar(props) {
  const { placeholder, value, name } = props;
  const classes = useStyles(); 
 
  return (
    <div className={"row search-wrapper"}>
      <div className={classes.search}>
        <TextField
          placeholder={placeholder}
          onKeyPress={(e) =>
            e.key === "Enter" && props.isOwner == true
              ? props.onChange(e, value, 1)
              : null}
          onChange={(event) => props.onChange(event, event.target.value)}
          name={name}
          style={{
            width: "100%",
          }}
          value={value}
          InputProps={{
            endAdornment: props.isOwner && (
              <InputAdornment position={"start"}>
                <Tooltip title={"Search Company"}>
                  <img
                    src={FilterImage}
                    alt={"logo"}
                    className={"stream-logo"}
                    style={{ paddingLeft: "10px", cursor: "pointer" }}
                    onKeyPress={(e) =>
                      e.key === "Enter" && props.isOwner == true
                        ? props.onChange(e, value, 1)
                        : null}
                     onClick={(event) =>
                      props.isOwner == true
                        ? props.onChange(event, value, 1)
                        : null}
                  />
                </Tooltip>
              </InputAdornment>
            ),
          }}
        />
      </div>
    </div>
  );
}
